import { Button as NextButton } from '@heroui/button';
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@ds';
import { useState } from 'react';
import { BsThreeDots } from 'react-icons/bs';

import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md';
import { toast } from 'react-toastify';
import { StatusGroup } from '@/store/cases-board.store';
import { CaseStatus } from '@/api/apis/case';
import { SelectedStatus } from './SelectedStatus';

type SavedGroupProps = {
  onEdit: (id: string, name: string, statuses: CaseStatus[]) => void;
  onDelete: (id: string) => void;
  onStatusDelete: (id: string, selectedStatus: CaseStatus) => void;
} & StatusGroup;

export const SavedGroup = ({ id, statuses, name, onEdit, onDelete, onStatusDelete }: SavedGroupProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleStatusDelete = (selectedStatus: CaseStatus) => {
    if (statuses.length === 1) {
      toast.info('The last status cannot be deleted');
      return;
    }
    onStatusDelete(id, selectedStatus);
  };

  return (
    <div>
      <Button
        variant="light"
        className="flex justify-between items-center w-full bg-info-80 rounded-lg p-3 text-m-m text-info-5 mb-1 hover:bg-info-80!"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center gap-2">
          <div className="flex-1 truncate max-w-60 text-m-m font-medium">{name}</div>
          <div className="flex justify-center items-center rounded-full p-0.5 bg-info-70">
            {expanded ? <MdOutlineKeyboardArrowUp size={12} /> : <MdOutlineKeyboardArrowDown size={12} />}
          </div>
        </div>
        <Dropdown placement="bottom-start" className="bg-base-60">
          <DropdownTrigger>
            <NextButton
              className="bg-transparent p-0 min-w-0"
              radius="full"
              disableRipple
              endContent={<BsThreeDots size={24} />}
            />
          </DropdownTrigger>
          <DropdownMenu selectionMode="single" selectedKeys={[]}>
            <DropdownItem key="edit" onClick={() => onEdit(id, name, statuses)}>
              Edit Group
            </DropdownItem>
            <DropdownItem key="delete" onClick={() => onDelete(id)}>
              Delete Group
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Button>
      {expanded && (
        <div className="overflow-y-auto bg-info-90 rounded-lg">
          {statuses.map((selectedStatus) => (
            <SelectedStatus
              key={selectedStatus}
              onClick={() => handleStatusDelete(selectedStatus)}
              status={selectedStatus}
            />
          ))}
        </div>
      )}
    </div>
  );
};
